import { BaseDto } from './base.dto';
import { ProductDto } from './product.dto';
import { StockDto } from './stock.dto';
import { StockUnitDto } from './stockUnit.dto';

export class ProductStockIngredientDto extends BaseDto {
  stockId: number;
  quantity: number;
  unitId: number;
  productId: number;
  stock: StockDto;
  unit: StockUnitDto;
  product: ProductDto;
}
